import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { media } from "../io";
import { themes } from "../styles/ColorsStyle";
import {  MediumText } from "../styles/TextStyles";




export function CardWork(props) {

  function tk_mkt_work(){
    window.gtag('event', 'conversion', {
      'send_to': 'AW-473881585/1GEVCNj9i4oYEPG3--EB'
    });
  }


  return (
    <Wrapped>
      <a href={props.whatsapp} onClick={tk_mkt_work} target="_blank">
        <Cover {...props} />
      </a>
    </Wrapped>
  );
}

const Wrapped = styled.article`
  max-height: 380px;
  display: grid;
  grid-template-rows: 200px;
  gap: 20px;
  background: #ffffff;
  border: 0.5px solid ${themes.light.gray6};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  *,
  & {
    transition: 1s cubic-bezier(0.17, 0.67, 0.83, 0.67);
  }
  :hover {
    /* grid-template-rows: 200px 1fr; */
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
    transform: translateY(-3px);
  }
  div {
    opacity: 0;
    visibility: hidden;
  }
  @media (${media.tablet}) {
    max-height: 340px;
  }
`;

const Cover = (props) => (
  <WrappedImage>
    <Image src={props.image} />
  </WrappedImage>
);

const WrappedImage = styled.figure`
  position: relative;
  display: grid;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 20px 20px 20px 20px;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

const Text = styled(MediumText)`
  font-weight: bold;
  color: ${themes.light.gray};
  margin: 0;
  padding: 0 30px 30px;
  @media (${media.tablet}) {
    font-size: 1.2em;
    padding: 0 20px;
  }
`;

const WrappedButton = styled.div`
  padding: 0 30px 30px 30px;
  @media (${media.tablet}) {
    padding: 0 20px 20px 20px;
  }
`;
